module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_10.1ac566c8.pdf";